// extracted by mini-css-extract-plugin
module.exports = {"root":"bTNpvGqdOW2AHYJwF3UC","label":"MKYJxLmCizb6yoQbc22s","statistics":"UoQquyebeXhzbNGihwlx"};